module.exports = __webpack_public_path__ + "img/jersey_icon.b5e7ead2.png";